import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card mw-650px mx-auto" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "mx-auto" }
const _hoisted_4 = { class: "d-none d-flex flex-column mb-10 fv-row" }
const _hoisted_5 = { class: "d-flex mb-3 fs-5 text-gray-600" }
const _hoisted_6 = { class: "required" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "badge badge-light text-gray-300 text-nowrap" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex mb-3 fs-5 text-gray-600" }
const _hoisted_13 = { class: "required" }
const _hoisted_14 = { class: "d-flex flex-equal justify-content-between flex-shrink-1 flex-wrap gap-2" }
const _hoisted_15 = { class: "w-100 d-flex align-items-center justify-content-between py-1" }
const _hoisted_16 = { class: "symbol symbol-50px symbol-circle ms-1" }
const _hoisted_17 = { class: "svg-icon svg-icon-2 svg-icon-primary mx-auto" }
const _hoisted_18 = { class: "fw-bolder text-wrap fs-6" }
const _hoisted_19 = { class: "d-none form-check form-check-custom form-check-success form-check-solid ms-3" }
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-column mb-10"
}
const _hoisted_22 = { class: "text-gray-400 p-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle ms-1" }, null, -1)
const _hoisted_24 = {
  key: 1,
  class: "mb-10"
}
const _hoisted_25 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_26 = { class: "alert bg-light-info border border-info border-dashed d-flex flex-column justify-content-center w-100 p-5 mt-5" }
const _hoisted_27 = { class: "d-flex flex-column" }
const _hoisted_28 = { class: "mb-1 text-info" }
const _hoisted_29 = { class: "svg-icon svg-icon-2hx svg-icon-info me-4" }
const _hoisted_30 = {
  key: 0,
  class: "d-flex flex-column justify-content-center"
}
const _hoisted_31 = { class: "d-flex justify-content-center align-items-center py-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-info ms-1" }, null, -1)
const _hoisted_33 = { class: "d-flex justify-content-center align-items-center py-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-info ms-1" }, null, -1)
const _hoisted_35 = { class: "d-flex justify-content-center align-items-center py-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-info ms-1" }, null, -1)
const _hoisted_37 = { class: "d-flex justify-content-center align-items-center py-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-info ms-1" }, null, -1)
const _hoisted_39 = {
  key: 1,
  class: "d-flex flex-column justify-content-center"
}
const _hoisted_40 = { class: "d-flex justify-content-center align-items-center py-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-info ms-1" }, null, -1)
const _hoisted_42 = ["href"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-excel" }, null, -1)
const _hoisted_44 = { class: "d-flex align-items-center justify-content-between py-1" }
const _hoisted_45 = { class: "form-check form-check-custom form-check-success form-check-solid ms-3" }
const _hoisted_46 = { class: "symbol symbol-50px symbol-circle ms-1" }
const _hoisted_47 = { class: "svg-icon svg-icon-2 svg-icon-primary mx-auto" }
const _hoisted_48 = { class: "fw-bolder text-wrap fs-6" }
const _hoisted_49 = { class: "indicator-label" }
const _hoisted_50 = { class: "indicator-progress" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_platform = _resolveComponent("platform")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Tree = _resolveComponent("Tree")!
  const _component_UploadFile = _resolveComponent("UploadFile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.translate("Choose a subscription")), 1)
          ]),
          _createVNode(_component_el_select, {
            size: "large",
            name: "robot",
            modelValue: _ctx.dataHolder.bot_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataHolder.bot_id) = $event)),
            placeholder: _ctx.translate('subscription'),
            disabled: !_ctx.botList || !_ctx.botList.length,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataHolder.platforms = []))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.botList, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  value: item.bot_id,
                  label: item.name,
                  disabled: !_ctx.checkBotHasActivePlatform(item.platforms)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, _toDisplayString(item.name), 1),
                      _createElementVNode("div", null, [
                        (item.platforms.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.platforms, (plat, platIndex) => {
                                return (_openBlock(), _createBlock(_component_platform, {
                                  key: platIndex,
                                  class: "ms-1",
                                  status: plat.status,
                                  platform: plat.platform,
                                  avatar: plat.avatar,
                                  logo: plat.platform_avatar,
                                  number: plat.platform_number,
                                  "package-support": 
                        _ctx.checkPackagePlatform(
                          item.package.platforms,
                          plat.platform
                        )
                      ,
                                  showBtns: false,
                                  size: `25px`
                                }, null, 8, ["status", "platform", "avatar", "logo", "number", "package-support"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate("No connected platform found")), 1)
                            ]))
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["value", "label", "disabled"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate("How to enter numbers")), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputNumberType, (item, index) => {
              return (_openBlock(), _createElementBlock("label", {
                key: index,
                class: _normalizeClass(["d-flex flex-stack mb-5 cursor-pointer btn btn-outline btn-outline-dashed p-2", 
                  _ctx.dataHolder.numbersInputType === item.name
                    ? 'border-success bg-light-success text-success'
                    : ''
                ])
              }, [
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, {
                        src: `media/icons/duotune/${item.icon}`
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate(item.name)), 1),
                  _createElementVNode("span", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "platforms",
                      value: item.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataHolder.numbersInputType) = $event))
                    }, null, 8, _hoisted_20), [
                      [_vModelRadio, _ctx.dataHolder.numbersInputType]
                    ])
                  ])
                ])
              ], 2))
            }), 128))
          ])
        ]),
        (_ctx.dataHolder.numbersInputType === 'manual')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_el_input, {
                autosize: { minRows: 2, maxRows: 8 },
                type: "textarea",
                name: "numbers",
                placeholder: "9376080467",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (
                     _ctx.recipients = _ctx.toEnglishDigits(
                       _ctx.recipients
                      )
                    )),
                modelValue: _ctx.recipients,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.recipients) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createTextVNode(_toDisplayString(_ctx.translate("Please put each number on a new line")), 1)
              ])
            ]))
          : (_ctx.dataHolder.numbersInputType === 'phonebook')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_Tree, {
                  numbersTree: _ctx.phonebooksTree,
                  ref: "treeRef"
                }, null, 8, ["numbersTree"])
              ]))
            : (
            ['excel', 'variable'].includes(_ctx.dataHolder.numbersInputType)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (_openBlock(), _createBlock(_component_UploadFile, {
                    type: "big",
                    key: _ctx.dataHolder.numbersInputType,
                    url: "upload/excel",
                    title: "Select Excel file",
                    onUploadSuccess: _ctx.exelUploadedCallBack,
                    classes: "mw-400px"
                  }, null, 8, ["onUploadSuccess"])),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("h4", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.translate("pay attention")), 1)
                      ]),
                      (_ctx.dataHolder.numbersInputType === 'variable')
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [
                            _createElementVNode("li", _hoisted_31, [
                              _hoisted_32,
                              _createTextVNode(_toDisplayString(_ctx.translate("In column A: Enter your numbers")), 1)
                            ]),
                            _createElementVNode("li", _hoisted_33, [
                              _hoisted_34,
                              _createTextVNode(_toDisplayString(_ctx.translate("In column B: enter your first variable")), 1)
                            ]),
                            _createElementVNode("li", _hoisted_35, [
                              _hoisted_36,
                              _createTextVNode(_toDisplayString(_ctx.translate("In column C: enter your second variable")), 1)
                            ]),
                            _createElementVNode("li", _hoisted_37, [
                              _hoisted_38,
                              _createTextVNode(_toDisplayString(_ctx.translate("In column D: Enter your third variable")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dataHolder.numbersInputType === 'excel')
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                            _createElementVNode("li", _hoisted_40, [
                              _hoisted_41,
                              _createTextVNode(_toDisplayString(_ctx.translate("In column A: Enter your numbers")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("a", {
                        href: 
                  _ctx.dataHolder.numbersInputType === 'excel'
                    ? 'https://inboxino.com/media/samples/sample.xlsx'
                    : 'https://inboxino.com/media/samples/send-with-variables.xlsx'
                ,
                        download: "",
                        class: "text-muted fw-bold text-hover-primary text-info d-block fs-7 mt-3"
                      }, [
                        _hoisted_43,
                        _createTextVNode(" " + _toDisplayString(_ctx.translate("Download the sample file")), 1)
                      ], 8, _hoisted_42)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
        _createElementVNode("label", {
          class: _normalizeClass(["d-flex flex-stack mb-5 cursor-pointer btn btn-outline btn-outline-dashed p-2", 
            _ctx.dataHolder.with_country_code === true
              ? 'border-success bg-light-success text-success'
              : ''
          ])
        }, [
          _createElementVNode("span", _hoisted_44, [
            _createElementVNode("span", _hoisted_45, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                name: "platforms",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataHolder.with_country_code) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.dataHolder.with_country_code]
              ])
            ]),
            _createElementVNode("span", _hoisted_46, [
              _createElementVNode("span", _hoisted_47, [
                _createVNode(_component_inline_svg, { src: `media/icons/duotune/maps/map004.svg` }, null, 8, ["src"])
              ])
            ]),
            _createElementVNode("span", _hoisted_48, [
              _createTextVNode(_toDisplayString(_ctx.translate("Add the country code to the first numbers")) + ". ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.user?.country?.phone_code), 1)
            ])
          ])
        ], 2),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addRecipientSubmit && _ctx.addRecipientSubmit(...args))),
            type: "button",
            class: "btn btn-primary w-100",
            ref: "submitButton"
          }, [
            _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.translate("Add recipient")), 1),
            _createElementVNode("span", _hoisted_50, [
              _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
              _hoisted_51
            ])
          ], 512)
        ])
      ])
    ])
  ]))
}